module.exports = __webpack_public_path__ + "../resources/images/illustration_task-a96a5ee8a4ab9e556f8cf1a95cc9eb5b.svg";